import {GET_CUISINES} from "../actions/cuisine";

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CUISINES:
            return { ...state, ...action.payload.results };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/cuisine.js